import { Component, EventEmitter, OnChanges, OnDestroy, Input, Output, ViewChild, OnInit, SimpleChanges } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { URLS } from '../../constant/interface';
import { generateUUID } from '../../utils/common';
import { DialogService } from '../../services/dialog.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-video',
  templateUrl: './icc-video.component.html',
  styleUrls: ['./icc-video.component.less'],
})
export class IccVideoComponent implements OnChanges, OnDestroy, OnInit {
  constructor(private http: _HttpClient, private dialogService: DialogService) {}
  @ViewChild('input', { static: false }) input: any;
  @ViewChild('videoview', { static: false }) videoView: any;
  // 视频地址
  @Input() url: string;
  // 封面地址
  @Input() coverUrl: string;
  // 视频缓冲地址，按需加载视频
  @Input() bufferUrl: string;
  // 接口地址
  @Input() req: string;
  @Input() size = 300;
  // 是否禁用操作（重新上传、删除）
  @Input() disabled: boolean;
  // 仅展示展示封面海报， 为true时，则仅显示封面海报，隐藏播放按钮
  @Input() showPoster: boolean;
  // tslint:disable-next-line: no-output-native
  @Output() success: EventEmitter<any> = new EventEmitter<any>();
  @Output() fail: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() videoRemove: EventEmitter<any> = new EventEmitter<any>();

  @Output() closeModel: EventEmitter<any> = new EventEmitter<any>();
  @Output() loadReady: EventEmitter<any> = new EventEmitter<any>();

  @Input() name = '';
  @Input() status: string;
  @Input() vTypes = ['mp4', 'flv', 'mov', 'ogg', 'rm', 'rmvb', 'wmv', 'avi', 'webm'];
  @Input() typeDescript = '推荐格式MP4、webm。';
  // 当加载完100%时才能重新上传
  @Input() tryAgain: boolean = true;
  // 整个组件大小的缩放
  @Input() scale: number = 1;

  // 加载视频中
  loading = true;
  statusInfo = {
    nothing: '1',
    loading: '2',
    fail: '3',
    success: '4',
    playing: '5',
    onlyPlay: '6',
    damaged: '7',
  };
  // 异常提示
  errorMsg: string;
  // 上传速度
  speed: number;
  // 剩余时间
  remaining: number;
  // 上传的视频标识uuid
  uuid: string;

  // 获取时间进度的定时器
  intervalTimer: any;

  // 上传进度
  progress = 0;
  progressList = [3, 10, 15, 36, 50, 57, 63, 77, 88, 98, 100];
  count = 0;

  // 控制取消上传之后，url不会被赋值
  isBreak: boolean;
  // 控制重复请求上传
  isCanUpload: boolean;

  showPosterImg: boolean;
  posterImg: string;

  hasvideoUrl: boolean;

  ngOnInit() {
    this.url = this.url || '';
    this.name = this.name || '';
    this.req = this.req || '';
    this.disabled = this.disabled === true ? true : false;
    this.ngOnChanges();
  }
  ngOnChanges() {
    if (!this.url) {
      this.status = this.statusInfo.nothing;
    } else if (this.url && this.status !== this.statusInfo.fail && this.status !== this.statusInfo.playing && this.status !== this.statusInfo.onlyPlay) {
      // this.streamLoad(this.url);
      this.status = this.statusInfo.success;
    }
    this.hasvideoUrl = !!(this.bufferUrl || this.url);
    this.isCanUpload = true;
  }
  ngOnDestroy(): void {
    if (this.intervalTimer) {
      clearInterval(this.intervalTimer);
      this.intervalTimer = null;
      console.log('ngOnDestroy');
    }
  }

  // 打开文件框
  selectFile(evt) {
    if (!this.disabled) {
      this.input.nativeElement.click();
    }
  }

  // 选择文件
  fileChange(evt) {
    if (!this.isCanUpload) {
      this.dialogService.notification.warning('提示', '上传间隔频繁，请重试');
      return;
    }
    if (!evt.target.files || !evt.target.files[0]) {
      return false;
    }
    const file = evt.target.files[0];
    this.name = file.name;
    this.errorMsg = this.fileCheck(file);
    if (this.errorMsg) {
      this.status = this.statusInfo.fail;
      return false;
    }
    this.requestFileUpload(file);
    this.setLoadingState(true);
  }

  // 上传文件
  requestFileUpload(file) {
    const formData = new FormData();
    this.uuid = generateUUID();
    formData.append('file', file as any);
    this.isBreak = false;
    this.url = '';
    this.isCanUpload = false;
    this.http.post(this.req, formData).subscribe(
      res => {
        this.isCanUpload = true;
        if (this.isBreak) {
          this.status = this.statusInfo.fail;
          this.errorMsg = '视频已取消上传';
          return false;
        }
        this.input.nativeElement.value = '';
        if (res.status === 0) {
          this.status = this.statusInfo.success;
          this.success.emit(res.data);
          console.log(`======== 上传完成 ======`);

          this.progress = 100;
        } else {
          this.fail.emit(res.data);
          this.errorMsg = res.errMsg;
          this.status = this.statusInfo.fail;
        }
      },
      error => {
        if (this.isBreak) {
          this.status = this.statusInfo.fail;
          this.errorMsg = '视频已取消上传';
          return false;
        }
        this.isCanUpload = true;
        this.errorMsg = '上传失败';
        this.status = this.statusInfo.fail;
      },
    );
    // 获取进度
    if (!this.intervalTimer) {
      this.progress = 0;
      this.count = 0;
      this.status = this.statusInfo.loading;
      this.intervalTimer = setInterval(() => {
        this.getUploadProgress();
      }, 200);
    } else {
      clearInterval(this.intervalTimer);
      this.intervalTimer = null;
    }
  }
  // ajax轮询获取上传进度
  getUploadProgress() {
    this.http.post(URLS.templateMediaUploadState.url).subscribe(
      res => {
        // res.data = this.progressList[this.count] + '';
        // this.count = (this.count + 1) % this.progressList.length;
        if (res.status === 0 && res.data && this.progress !== 100 && this.status === this.statusInfo.loading) {
          this.progress = Number(res.data);
          if (res.data !== '100') {
            this.status = this.statusInfo.loading;
          } else {
            if (res.data == '100') {
              this.status = this.statusInfo.success;
            }
            if (this.intervalTimer) {
              clearInterval(this.intervalTimer);
              this.intervalTimer = null;
            }
          }
        } else if (this.intervalTimer) {
          clearInterval(this.intervalTimer);
          this.intervalTimer = null;
        }
      },
      () => {
        if (this.intervalTimer) {
          clearInterval(this.intervalTimer);
          this.intervalTimer = null;
        }
      },
    );
  }

  // 文件格式、大小校验
  fileCheck(file) {
    let errorMsg;
    switch (true) {
      case !file.type.startsWith('video/'):
        errorMsg = '不支持该格式';
        break;
      case this.vTypes.indexOf(file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase()) === -1:
        errorMsg = '不支持该视频格式';
        break;
      case file.size / 1024 / 1024 > this.size:
        errorMsg = '视频大小超过' + this.size + 'M';
        break;
    }
    // 校验失败后，可重新上传
    return errorMsg;
  }

  // 取消上传
  uploadCancel(evt) {
    this.cancel.emit(evt);
    this.isBreak = true;
    this.input.nativeElement.value = '';
    // 取消上传接口待对接
    if (this.intervalTimer) {
      clearInterval(this.intervalTimer);
      this.intervalTimer = null;
    }
  }

  // 删除视频
  remove() {
    // 删除接口待对接
    this.status = this.statusInfo.nothing;
    this.videoRemove.emit();
    this.url = '';
    this.input.nativeElement.value = '';
    this.setLoadingState(true);
  }

  // 打开视频
  openPlay() {
    console.log('打开视频');
    this.status = this.statusInfo.playing;
    // 缓冲测试
    // setInterval(() => {
    // const video: any = document.getElementById('video-id');
    // if (video.buffered) {
    //     console.log('start:' + video.buffered.start(0) + '---- end:' + video.buffered.end(0));
    // }
    // }, 200);
  }

  // 关闭视频
  close() {
    console.log('关闭视频');
    if (this.status === this.statusInfo.onlyPlay) {
      this.closeModel.emit();
    } else {
      this.status = this.statusInfo.success;
    }
  }
  // 设置视频状态
  setLoadingState(loading?: boolean): void {
    loading ? (this.loading = true) : (this.loading = false);
    this.showPosterImg = false;
  }

  /* 设置视频封面 */
  setPoster() {
    const video = this.videoView.nativeElement;
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth * 1;
    canvas.height = video.videoHeight * 1;
    if (canvas.width == 0 || video.videoHeight == 0) {
      this.dialogService.notification.warning('提示', '视频有误，请重试');
      if (this.disabled) {
        this.status = this.statusInfo.damaged;
      } else {
        this.remove();
      }
      return;
    }
    canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
    try {
      let src = canvas.toDataURL('image/png');

      // 封面显示在dom，测试用
      /* (flag => {
        if (!flag) {
          return;
        }
        let img = document.createElement('img');
        img.src = src;
        document.body.appendChild(img);
      })(true); */

      video.setAttribute('poster', src);
      this.setLoadingState(false);
      this.loadReady.emit('loadReady!');
      this.posterImg = src;
      this.showPosterImg = true;
    } catch (error) {}
  }

  // get hasvideoUrl(): boolean {
  //   let hasBuffUrl = this.bufferUrl ? true : false;
  //   let hasUrl = this.url ? true : false;
  //   return hasBuffUrl || hasUrl;
  // }

  // video 标签流式加载
  // streamLoad(url) {
  //   let xhr = new window.XMLHttpRequest();
  //   xhr.responseType = 'arraybuffer';
  //   xhr.open('get', url);
  //   // xhr.setRequestHeader('Range', `bytes=0-390625`)
  //   xhr.onload = function() {
  //     if (xhr.status === 200 || xhr.status === 206) {
  //       console.log(xhr.response);
  //     }
  //   };
  //   xhr.send();
  // }
}
